import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
class PayHead extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			payhead : '',
			desc : '',
			ptype : '',
			stype : '',
			_message : '',
			alertClass :'',
			posts : []
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("payhead").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/addpayhead',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Pay Head Added Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("payhead").reset();
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	/** this function will be call when page loading **/
	componentDidMount() {
		
		this.getdata();		
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('payroll/getpayhead').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			PostData('payroll/deletephead',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'PayHead Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove PayHead',
						alertClass:'alert alert-danger'
					});
				}
			});
		}	
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to={'/employee/payroll/editpayhead/' + this.state.idd} />);

	}
	
	  /** set value to payhead type **/	
	this.phtype = [
		{value : '', name : 'Select'},
		{value : 'addition', name : 'Addition'},
		{value : 'deduction', name : 'Deduction'}
	];
	
	  /** set value to Setup type **/	
	this.settype = [
		{value : '', name : 'Select'},
		{value : 'onetime/annual', name : 'One Time/Annual'},
		{value : 'monthly/other', name : 'Monthly/Other'}
	];
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="5">
				<Card>
				  <form action="" method="post" role="form" id="payhead" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Pay Head Type</strong>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Pay Head Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="payhead" required onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Description</Label>
							  <Input type="textarea" name="desc" onChange={this.onChange} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Payhead Type <span className="text-danger">*</span></Label>
							  <select name="ptype" onChange={this.onChange} className="form-control" required>
								{this.phtype.map((e,key)=>{
									return <option key={key} value={e.value}>{e.name}</option>
								})}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Setup Type <span className="text-danger">*</span></Label>
							  <select name="stype" onChange={this.onChange} className="form-control" required>
								{this.settype.map((e,key)=>{
									return <option key={key} value={e.value}>{e.name}</option>
								})}
							  </select>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			  <Col md="7">
			   <Card>
				<CardBody>
				<Table responsive bordered>
					<thead>
						<tr>
							<th>S.No</th>
							<th>Pay Head Name</th>
							<th>Description</th>
							<th>Payhead Type</th>
							<th>Setup Type</th>
							<th width="100">Manage</th>
						</tr>
					</thead>
					<tbody>
						{this.state.posts.map((item,i) =>
						 
							<tr key = {item}>
								<td>{i+1}</td>
								<td>{item.payheadname}</td>
								<td>{item.description}</td>
								<td className="txt-capital">{item.type}</td>
								<td className="txt-capital">{item.setup}</td>
								<td>
									<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
									&nbsp;&nbsp;
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>
			  
						 )}
					</tbody>
				</Table>
				</CardBody>
			   </Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default PayHead;


// WEBPACK FOOTER //
// ./src/payroll/PayHead/PayHead.js